import { Phone, MapPin, UtensilsCrossed } from "lucide-react";
import { BUSINESS } from "@/data/site";

// Sticky bottom action bar — mobile only. Click-to-call + directions + menu.
export default function MobileActionBar() {
  const items = [
    { label: "Call", href: `tel:${BUSINESS.phoneHref}`, icon: Phone, testid: "mobilebar-call", primary: true },
    { label: "Directions", href: BUSINESS.directionsUrl, icon: MapPin, testid: "mobilebar-directions", external: true },
    { label: "Menu", href: "/menu", icon: UtensilsCrossed, testid: "mobilebar-menu" },
  ];
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 lg:hidden border-t border-brand-ink/10 bg-brand-cream/95 backdrop-blur-xl"
      data-testid="mobile-action-bar"
    >
      <div className="grid grid-cols-3">
        {items.map((it) => {
          const Icon = it.icon;
          const cls = `flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium tracking-wide transition-colors ${
            it.primary ? "text-white bg-brand-red" : "text-brand-ink hover:text-brand-red"
          }`;
          return (
            <a
              key={it.label}
              href={it.href}
              className={cls}
              data-testid={it.testid}
              {...(it.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              <Icon size={18} />
              {it.label}
            </a>
          );
        })}
      </div>
    </div>
  );
}
